import moment from 'moment';

import { RequestItem } from 'bus/request/types';

const date = moment(
  moment().utc().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD HH:mm:ss'),
).toDate();

export const initialForm = (): RequestItem => ({
  id: 0,
  isDeleted: false,
  date: date,
  contractorId: null,
  objectId: null,
  quantity: 0,
  delivery: 0,
  deliveryFilledManually: false,
  price: 0,
  priceFilledManually: false,
  shipped: 0,
  total: 0,
  requestTotal: 0,
  density: 4,
  phone: '',
  nomenclatureId: null,
  providerId: null,
  builderId: null,
  consigneeId: null,
  requestStatus: 0,
  contractorType: null,
  isPostponed: false,
  fault: 0,
  isCustomFault: false,
  customNomenclatureNameId: null,
  barterValue: '',
  factoryId: null,
  requestTotalWithFault: 0,
  design: '',
  paymentMethod: null,
  methodOfReceptionTotalSum: 0,
  methodOfReception: {
    pumpPhone: '',
    pumpQuantity: 0,
    pumpInnings: 0,
    pumpQuencher: 0,
    useQuencher: false,
    pumpMoving: 0,
    pumpPipes: 0,
    downtime: 0,
    comment: '',
    driverId: null,
    driverIds: [],
    glassConcretePrice: null,
    pumpDelivery: null,
    pumpPrice: 0,
    pumpPriceMinimal: 0,
    pumpTotal: null,
    requestId: null,
    transportId: null, //по дефолту рюмка
    type: 0,
    pumpMovingCount: 0,
    pumpPipesCount: 0,
    downtimeHours: 0,
    pumpQuencherFilledManually: false,
    pumpInningsFilledManually: false,
    pumpMovingFilledManually: false,
    pumpPipesFilledManually: false,
    downtimeFilledManually: false,
    pumpDeliveryFilledManually: false,
    distance: 0,
  },
  comment: '',
});
